import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../../../packages/api-models/common/json_query';

export function trackMapInteraction(jsonQuery: IJsonQuery) {
  ca('eventSite', {
    event: 'oldevent',
    name: 'oldevent',
    category: 'Map',
    action: 'click_sopr',
    label: 'map_action',
    page: {
      pageType: 'Map',
      queryString: window.location.search,
    },
    sc: jsonQuery,
  });
}
